import api from '../../lib/api';

export type CustomerAppHomeImage = {
  url: string;
  positionX: number;
  positionY: number;
};

export type CustomerAppHomeSettings = {
  customer_app_common_home_images: CustomerAppHomeImage[];
};

export const fetchCustomerAppHomeSettings = async (): Promise<CustomerAppHomeSettings> => {
  const response = await api.get('/api/customer-app/home-settings');
  const data = response.data as Partial<CustomerAppHomeSettings> | null | undefined;
  const commonHomeImagesValue = data?.customer_app_common_home_images;
  const commonHomeImages = Array.isArray(commonHomeImagesValue)
    ? (commonHomeImagesValue as unknown[])
      .map((item) => {
        if (typeof item === 'string' && item.trim()) {
          return { url: item.trim(), positionX: 50, positionY: 50 };
        }
        if (!item || typeof item !== 'object' || Array.isArray(item)) {
          return null;
        }
        const record = item as Record<string, unknown>;
        const url = typeof record.url === 'string' ? record.url.trim() : '';
        if (!url) return null;
        const positionX = Number.isFinite(Number(record.positionX)) ? Number(record.positionX) : 50;
        const positionY = Number.isFinite(Number(record.positionY)) ? Number(record.positionY) : 50;
        return {
          url,
          positionX: Math.max(0, Math.min(100, Math.round(positionX))),
          positionY: Math.max(0, Math.min(100, Math.round(positionY))),
        };
      })
      .filter((item): item is CustomerAppHomeImage => Boolean(item))
    : [];
  return {
    customer_app_common_home_images: commonHomeImages,
  };
};
